import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "@tanstack/react-store";
import { useTranslation } from "react-i18next";
import { store } from "../../../store/store";
import { getQueryStringFromParams } from "../../api/utils/paramUtils";
import {
    BASE_API_URL,
    HttpError,
} from "../../api/utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../../api/utils/useHttpGovernmentAgencyHubAppHeaders";
import type { SubjectsDto } from "./SubjectsDto";

export function useGetSubjects() {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders();
    const { t } = useTranslation();

    const filters = useSelector(
        store,
        (state) => state.taxSubmissionsSearchFilters,
    );

    const queryParams = {
        deadlineFrom: filters.deadlineFrom.getTime() || 0,
        deadlineTo: filters.deadlineTo.getTime() || 0,
        ...(filters.statuses.length > 0 ? { statuses: filters.statuses } : {}),
    };

    const queryString = getQueryStringFromParams(queryParams);

    const query = useQuery<SubjectsDto>({
        queryKey: ["useGetSubjects", workspaceId, queryString],
        queryFn: async () => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/subjects?${queryString}`,
                {
                    headers,
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },
        enabled: !!workspaceId,
        initialData: { intermediaries: [], operators: [] },
        placeholderData: { intermediaries: [], operators: [] },
        meta: {
            resourceName: t("errors.resourceName.subjects"),
        },
    });

    return query;
}
